import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ConfigService, TokenService } from 'viggo-sistemas-core-web';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IRole } from 'viggo-sistemas-core-web/modules/role/model/role.model';

export interface ISettings {
  [key: string]: any;
}
@Injectable()
export class DomainSettingsService {
  baseEntityEndPoint: string;
  urlBackend: string;

  constructor(
    protected http: HttpClient,
    protected configService: ConfigService,
    protected tokenService: TokenService
  ) {
    Object.assign(this, {
      baseEntityEndPoint: `domains/${tokenService.getDomain().id}/settings`,
      urlBackend: configService.backendURL
    });
  }

  getBaserUrl(): string {
    return `${this.urlBackend}${this.baseEntityEndPoint}`;
  }

  insert(data: ISettings): Observable<ISettings> {
    const headers = new HttpHeaders().append(
      'token',
      this.tokenService.getToken().id
    );

    return this.http
      .post<{ settings: ISettings }>(this.getBaserUrl(), data, {
        headers
      })
      .pipe(map(item => item.settings));
  }

  update(data: ISettings, domainId?: string): Observable<ISettings> {
    const headers = new HttpHeaders().append(
      'token',
      this.tokenService.getToken().id
    );

    return this.http
      .put<{ settings: ISettings }>(
        domainId
          ? `${this.urlBackend}domains/${domainId}/settings`
          : this.getBaserUrl(),
        data,
        {
          headers
        }
      )
      .pipe(map(item => item.settings));
  }

  delete(key: string): Observable<ISettings> {
    const headers = new HttpHeaders().append(
      'token',
      this.tokenService.getToken().id
    );

    return this.http
      .delete<{ settings: ISettings }>(`${this.getBaserUrl()}?keys=${key}`, {
        headers
      })
      .pipe(map(item => item.settings));
  }

  public getRoles(domainId: string): Observable<IRole[]> {
    const headers = new HttpHeaders().append(
      'token',
      this.tokenService.getToken().id
    );
    return this.http
      .get<{ roles: IRole[] }>(`${this.urlBackend}domains/${domainId}/roles`, {
        headers
      })
      .pipe(map(data => data.roles));
  }
}
